import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_2 = { class: "overflow-auto touch-pan-y max-h-[calc(100vh-200px)] border border-gray-300 rounded-md scroll-smooth" }
const _hoisted_3 = { class: "min-w-full mb-24 border-separate border-spacing-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppliedRequestRow = _resolveComponent("AppliedRequestRow")!
  const _component_ExpertRowItem = _resolveComponent("ExpertRowItem")!
  const _component_ReviewEntryModal = _resolveComponent("ReviewEntryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      _ctx.isRequestsLoading ||
      _ctx.isLoading ||
      _ctx.sendUserReminderEmailLoading ||
      _ctx.sendInvitationLoading ||
      _ctx.updateUserProgramStatusLoading
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("thead", { class: "sticky top-0 bg-white z-10" }, [
          _createElementVNode("tr", { class: "border-b border-gray-300" }, [
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider leading-4" }, " Name "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider leading-4" }, " Email "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider leading-4" }, " Total Thank You Payouts "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider leading-4" }, " Status "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider leading-4" }, " Last Activity "),
            _createElementVNode("th", { class: "px-4 py-2 text-center text-gray-500 text-xs font-medium tracking-wider leading-4" }, " Actions ")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.requests, (row, index) => {
            return (_openBlock(), _createBlock(_component_AppliedRequestRow, {
              key: 'request-' + row.id,
              row: row,
              rowIndex: index,
              convertToDate: _ctx.convertToDate,
              onReview: _ctx.handleReviewEntry
            }, null, 8, ["row", "rowIndex", "convertToDate", "onReview"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.activeExperts, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'active-' + row.id,
              row: row,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.interestedExperts, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'interested-' + row.id,
              row: row,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.interestedSignupExperts, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'signup-' + row.id,
              row: row,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.invitedExperts, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'invited-' + row.id,
              row: row,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.invitations, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'invitation-' + row.id,
              row: row,
              isInvitation: true,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.hiddenExperts, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'hidden-' + row.id,
              row: row,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRows.otherExperts, (row) => {
            return (_openBlock(), _createBlock(_component_ExpertRowItem, {
              key: 'other-' + row.id,
              row: row,
              originalInvitationRows: _ctx.originalInvitationRows,
              shouldDisable: _ctx.shouldDisable,
              getClassForStatus: _ctx.getClassForStatus,
              expertStatusText: _ctx.expertStatusText,
              performActionText: _ctx.performActionText,
              performAction: _ctx.performAction,
              handleMakeInactive: _ctx.handleMakeInactive,
              lastActivityText: _ctx.lastActivityText,
              invitationStatus: _ctx.invitationStatus,
              invitationLastActivityText: _ctx.invitationLastActivityText,
              handleSendInvitation: _ctx.handleSendInvitation,
              getStatusTooltip: _ctx.getStatusTooltip,
              menuOpenId: _ctx.menuOpenId,
              setMenuOpenId: _ctx.setMenuOpenId,
              rowId: row.id
            }, null, 8, ["row", "originalInvitationRows", "shouldDisable", "getClassForStatus", "expertStatusText", "performActionText", "performAction", "handleMakeInactive", "lastActivityText", "invitationStatus", "invitationLastActivityText", "handleSendInvitation", "getStatusTooltip", "menuOpenId", "setMenuOpenId", "rowId"]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.showReviewEntryModal)
      ? (_openBlock(), _createBlock(_component_ReviewEntryModal, {
          key: 1,
          isOpen: _ctx.showReviewEntryModal,
          onClose: () => (_ctx.showReviewEntryModal = false),
          expert: _ctx.requestsRows[_ctx.selectedRequestIndex]?.user,
          requestId: _ctx.requestsRows[_ctx.selectedRequestIndex]?.id,
          onRefreshRequests: _ctx.refreshExperts
        }, null, 8, ["isOpen", "onClose", "expert", "requestId", "onRefreshRequests"]))
      : _createCommentVNode("", true)
  ], 64))
}